// extracted by mini-css-extract-plugin
module.exports = {"open_hour":"OpenHourVisual_open_hour_1_gqj","opening_hours":"OpenHourVisual_opening_hours_3Bijn","time":"OpenHourVisual_time_1W9g7"};